import React, { useState } from 'react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { Button } from '../design-system';

interface DeleteButtonProps {
  onClick: () => void;
  fontSize?: number;
  noLoading?: boolean;
  [key: string]: any;
}

const DeleteButton = ({
  onClick,
  fontSize,
  noLoading,
  ...props
}: DeleteButtonProps) => {
  const [loading, setLoading] = useState(false);

  const handleDeletion = async () => {
    setLoading(true);
    try {
      await onClick();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      id="delete-button"
      title="Delete"
      type="button"
      aria-label="Delete Item"
      variant="primaryText"
      onClick={handleDeletion}
      loading={loading}
      {...props}
    >
      <FaRegTrashAlt fontSize={fontSize || 20} />
    </Button>
  );
};

export default DeleteButton;
